import React from 'react'
import FieldColumn from '../field-column'
import { Field } from 'formik'
import MultiSelectField from '../../form/fields/multi-select'
import { buildListAsInputOptions } from '../../../utils/forms'
import { useServicesQuery } from '../../../queries/services'
import { Element } from 'react-bulma-components'

interface ServiceFilterFieldProps {
  disabledQueries?: boolean
  queriesStaleTime?: number
  employerIds?: string[]
  tooltip?: string
}

const ServiceFilterField: React.FC<ServiceFilterFieldProps> = ({
  disabledQueries,
  queriesStaleTime,
  employerIds,
  tooltip,
}) => {
  const servicesQuery = useServicesQuery(
    { employer: employerIds },
    {
      enabled: !disabledQueries,
      staleTime: queriesStaleTime,
    },
  )

  return (
    <FieldColumn>
      <Element data-tooltip={tooltip}>
        <Field
          label="Affectation"
          name="service"
          component={MultiSelectField}
          options={buildListAsInputOptions(servicesQuery.data || [])}
          disabled={!servicesQuery.data || !servicesQuery.data[0]}
        />
      </Element>
    </FieldColumn>
  )
}

export default ServiceFilterField
